<template>
  <div class="rate-label">
    <p class="rate-label_name">{{name}}</p>
    <p class="rate-label_number">{{rate}}</p>
  </div>
</template>

<script>
'use strict';

export default {
    props: {
      name: String,
      rate: String
    }
  }
</script>

<style lang="sass">
.rate-label
  width: 100%
  margin-bottom: 1rem
  padding: 0.75rem
  display: flex
  align-items: center
  background-color: #242629
  border-radius: 5px
  p
    margin-bottom: 0
    padding: 0 5px
  &_name
    margin-right: auto
</style>